import ConfirmComponent from "./Confirm.vue"
import {
  EventBus
} from "./confirmEventBus"

const ConfirmPlugin = {
  install(Vue) {

    Vue.component('confirm', ConfirmComponent)

    Vue.prototype.$confirm = {

      open(title, msg) {
        return new Promise((resolve, reject) => {

           EventBus.$emit('ConfirmOpen', resolve, reject, title, msg)

        });

      },

    }

  }
}

export default ConfirmPlugin
